import DownloadIcon from '@mui/icons-material/Download';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs'
import Layout from '../../components/layout/Layout';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDocsFormData,
  selectDocsResponse,
  selectDocType,
  selectDownloadLoadingState,
  selectFeesFormData,
  selectFeesResponse,
  selectRefiDocsFormData,
  selectTitleCheckResponse,
  selectTitlePdfLoading,
  selectTransactionId
} from '../../redux-state/selectors';
import OutputLeftSide from '../../components/feeOutput.js/OutputLeftSide';
import OutputRightSide from '../../components/feeOutput.js/OutputRightSide';
import RefiDocOutputLeft from '../../components/refiDocsOutput/RefiDocOutputLeft';
import RefiDocsOutputRightSide from '../../components/refiDocsOutput/RefiDocsOutputRightSide';
import DocsOutputLeftSide from '../../components/docsOutput/DocsOutputLeftSide';
import DocsOutputRightSide from '../../components/docsOutput/DocsOutputRightSide';
import TitleOutputLeftSide from '../../components/title/TitleOutputLeftSide';
import TitleOutputRightSide from '../../components/title/TitleOutputRightSide';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import { generateFeesReport } from '../../components/utility/generateFeesReport';
import { generateDocsReport } from '../../components/utility/generateDocsReport';
import { DOWNLOAD_ALL, DOWNLOAD_TITLE_OUTPUT } from '../../redux-state/types';
import { useEffect } from 'react';
import { isLoggedIn } from '../../components/authProvider/AuthContext';
import { useNavigate } from 'react-router-dom';


function MultiPartFormOutput() {
  const feesResponseData = useSelector(selectFeesResponse);
  const docType =  useSelector(selectDocType);
  const transactionID =  useSelector(selectTransactionId);
  const titleResponse = useSelector(selectTitleCheckResponse);
  const feesFormData = useSelector(selectFeesFormData) || {};
  const docsOutput = useSelector(selectDocsResponse);
  const loadingState = useSelector(selectTitlePdfLoading);
  const simpleDocsFormData = useSelector(selectDocsFormData);
  const refiDocsFormData = useSelector(selectRefiDocsFormData);
  const loadingStateDocs = useSelector(selectDownloadLoadingState);
  const navigate = useNavigate();

  let docsFormData = docType === "Refi-Docs"? refiDocsFormData: simpleDocsFormData
  const dispatch = useDispatch();

  useEffect (() => {
    if(!isLoggedIn()) {
      navigate('/login')
    }
  });


  const convertToPdfFeesOutput = () => {
    if (!feesResponseData || Object.keys(feesResponseData).length === 0) {
      return;
    }
    const content = generateFeesReport(feesFormData, feesResponseData);

    const options = {
      filename: (feesResponseData["TransactionID"] ? `${feesResponseData["TransactionID"]}.pdf` : 'feesOutput.pdf'),
      image: { type: 'jpeg', quality: 0.98 }, // <-- controls embedded image quality
      jsPDF: {
        unit: 'in',
        format: 'letter', // equivalent to [8.5, 11], just clearer
        orientation: 'portrait',
      },
      html2canvas: {
        scale: 2, // default can render blurry text. 2 sharpens it
        useCORS: true, // if you load any external images
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }, // <-- if content spans multiple pages
    };
    html2pdf().set(options).from(content).save();
  };

  const convertToPdfDocsOutput = async () => {
    if (!docsOutput || Object.keys(docsOutput).length === 0) {
      return;
    }
    const content = generateDocsReport(docsFormData, docsOutput);

    const options = {
      filename: (transactionID ? `${transactionID}.pdf` : 'docsOutput.pdf'),
      image: { type: 'jpeg', quality: 0.98 }, // <-- controls embedded image quality
      jsPDF: {
        unit: 'in',
        format: 'letter', // equivalent to [8.5, 11], just clearer
        orientation: 'portrait',
      },
      html2canvas: {
        scale: 2, // default can render blurry text. 2 sharpens it
        useCORS: true, // if you load any external images
      },
      // Same page-break config as pages/docsOutput/index.js -- this is the other
      // route the refi docs report can be downloaded from (the multi-step form
      // lands here), so the two must agree or the same report paginates
      // differently depending on which form the user came through.
      //
      // 'avoid-all' used to be the mode here. It treats every element as
      // unbreakable, so each nested wrapper straddling a page boundary got its
      // own spacer and those compounded into large blank runs. Opt specific
      // blocks in instead, scoped the way the bot's print CSS scopes them.
      pagebreak: {
        mode: ['css', 'legacy'],
        avoid: ['.pdf-avoid-break', '.pdf-avoid-break .flex-row'],
      },
    };

    const blob = await html2pdf().set(options).from(content).outputPdf('blob');
    const pdfBlob = new File([blob], "myfile.pdf", { type: "application/pdf" });

    dispatch({
      type: DOWNLOAD_ALL,
      payload: pdfBlob,
    });
  };

  const convertToPdfTitleOutput = () => {
    dispatch({
      type: DOWNLOAD_TITLE_OUTPUT,
    });
  };

  return (
    <Layout>
      <div className='p-4 lg:p-8 min-h-[900px] bg-[default-bg-color]'>
        <div className='flex flex-row justify-between'>
          <div className='mb-4'>
            <CustomBreadcrumbs title={"Registration Form"} subtitle={"All Outputs"}/>
          </div>
        </div>

        <div className='text-3xl font-bold text-gray-900 mb-6'> All Output </div>

        {feesResponseData && Object.keys(feesResponseData).length > 0 &&
          <div className='bg-white p-4 mb-6 rounded-lg'>
            <div className='font-sans text-xl text-gray-800 mb-2'>Fees Output</div>
            <div className='text-gray-600'>
              Transaction ID: {feesResponseData["TransactionID"]}
            </div>

            <div className="w-full flex justify-end mb-8">
              <PrimaryButton
                text={<> <DownloadIcon sx={{ mr: '6px' }} /> Download </>}
                className="custom-download-button"
                onClick={convertToPdfFeesOutput}
              />
            </div>

            <div className='flex flex-col xl:flex-row w-full gap-6'>
              <div className='w-full xl:w-1/2 min-w-0'>
                <OutputLeftSide />
              </div>

              <div className="hidden xl:block w-px bg-gray-300" />

              <div className='w-full xl:w-1/2 min-w-0 xl:mt-3'>
                <OutputRightSide />
              </div>
            </div>
          </div>
        }

        {/* Document Output */}
        { docType &&
          <div className='bg-white p-4 mb-6 rounded-lg'>
            <div className='font-sans text-xl text-gray-800 mb-2'>Document Output</div>
            <div className='text-gray-600'>
              Transaction ID: {transactionID ? transactionID: '' }
            </div>

            <div className="w-full flex justify-end mb-8">
              <PrimaryButton
                text={
                  <>
                    <DownloadIcon sx={{ mr: '6px' }} />
                    Download
                    {loadingStateDocs && (
                      <span className="ml-4 animate-spin inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full mr-2" />
                    )}
                  </>
                }
                className="custom-download-button"
                disabled={loadingStateDocs}
                onClick={convertToPdfDocsOutput}
              />
            </div>

            <div className='flex flex-col xl:flex-row w-full gap-6'>
              <div className='w-full xl:w-1/2 min-w-0'>
                {docType==="Refi-Docs"? < RefiDocOutputLeft /> :  <DocsOutputLeftSide />}
              </div>

              <div className="hidden xl:block w-px bg-gray-300" />

              <div className='w-full xl:w-1/2 min-w-0'>
                {docType==="Refi-Docs"? <RefiDocsOutputRightSide /> :  <DocsOutputRightSide />}
              </div>
            </div>
          </div>
        }

        {/* Lien and Title Check */}
        { titleResponse && Object.keys(titleResponse).length > 0 &&
          <div className='bg-white p-4 mb-6 rounded-lg'>
            <div className='font-sans text-xl text-gray-800 mb-2'>Lien & Title Check</div>
            <div className='text-gray-600'>
              Transaction ID: {titleResponse? titleResponse["Transaction ID"] : ''}
            </div>

            <div className="w-full flex justify-end mb-8">
              <PrimaryButton
                text={
                  <>
                    <DownloadIcon sx={{ mr: '6px' }} />
                    Download
                    {loadingState && (
                      <span className="ml-4 animate-spin inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full mr-2" />
                    )}
                  </>}
                className="custom-download-button"
                disabled={loadingState}
                onClick={convertToPdfTitleOutput}
              />
            </div>

            <div className='flex flex-col xl:flex-row w-full gap-6'>
              <div className='w-full xl:w-1/2 min-w-0'>
                <TitleOutputLeftSide />
              </div>

              <div className='w-full xl:w-1/2 min-w-0 xl:mt-16'>
                <TitleOutputRightSide />
              </div>
            </div>
          </div>
        }
      </div>
  </Layout>
  )
}

export default MultiPartFormOutput